import React from "react";
import "./ScrollbarsCustom.css"; //"react-perfect-scrollbar/dist/css/styles.css";
import Scrollbars, { ScrollBarProps } from "react-perfect-scrollbar";
import { useLocation } from "react-router-dom";
import clsx from "clsx";
import ThemeHelper from "../../helpers/ThemeHelper";

type Props = {
  className?: string;
  useNative?: boolean;
  options?: ScrollBarProps;
  children?: React.ReactNode;
};

const ScrollbarsCustom: React.FC<Props> = (
  props: React.PropsWithChildren<Props>
) => {
  const { pathname } = useLocation();
  const isTouchDevice = ThemeHelper.isTouchDevice();
  const [scrollEl, setScrollEl] = React.useState<HTMLElement | null>();
  const divElementRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 0;
      scrollEl.scrollLeft = 0;
    }
    if (divElementRef.current) {
      divElementRef.current.scrollTop = 0;
      divElementRef.current.scrollLeft = 0;
    }
  }, [pathname]);

  React.useEffect(() => {
    if (
      (props.useNative || isTouchDevice) &&
      divElementRef.current &&
      props.options?.containerRef
    ) {
      props.options.containerRef(divElementRef.current);
    }
  }, []);

  return true || props.useNative || isTouchDevice ? (
    <div
      className={clsx(
        props.className,
        isTouchDevice ? undefined : "scrollbars-custom"
      )}
      ref={divElementRef}
      style={props.options?.style}
      onScroll={props.options?.onScroll}
    >
      {props.children}
    </div>
  ) : (
    <Scrollbars
      component="div"
      className={props.className}
      onScroll={(event) => event.stopPropagation()}
      onWheel={(event) => event.stopPropagation()}
      {...props.options}
      containerRef={(element) => {
        setScrollEl(element);
        if (props.options && props.options.containerRef)
          props.options.containerRef(element);
      }}
    >
      {props.children}
    </Scrollbars>
  );
};

export default ScrollbarsCustom;
